exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".N6cG5OwWabs5c1{border-radius:32px;font-size:12px;font-weight:400;line-height:16px;padding:2px 8px;text-align:center;text-transform:uppercase}._3_BUw86sJ8u9HQ{background-color:#d6ecd2;color:#49852e}._3VnRI9FunkfM51{background-color:#bcd9ea;color:#094c72}", ""]);

// exports
exports.locals = {
	"lozenge": "N6cG5OwWabs5c1",
	"green": "_3_BUw86sJ8u9HQ",
	"blue": "_3VnRI9FunkfM51"
};